module.exports = __webpack_public_path__ + "static/img/donga-stillen.e7f51a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/donga-stillen.jpg
// module id = /LvR
// module chunks = 0